import UrlAssembler from "url-assembler";

export default function generateUrl(urlBase, paramObj, queryObj) {
  return UrlAssembler()
    .template(urlBase)
    .param(paramObj)
    .query(queryObj)
    .toString();
}
